export const PRICES_COLUMNS = {
	name: "name",
	availability: "boolean_mkswcqbt",
	channel: "color_mkqetw85",
	workflowSteps: "dropdown_mkwkck54",
	jobs: "dropdown_mkqzqgq2",
	prices: "numeric_mkqeqzy7",
} as const;
